export const objectMerger = (full, diff) => {
    const saveDataObj = objectСopier(full) || {};
    for (const key in diff) {
        if (typeof diff[key] === 'object' && !Array.isArray(diff[key])) {
            saveDataObj[key] = objectMerger(saveDataObj[key], diff[key]);
        }
        else {
            saveDataObj[key] = diff[key];
        }
    }
    return saveDataObj;
};
const objectСopier = (obj) => {
    if (!obj)
        return obj;
    return JSON.parse(JSON.stringify(obj));
};



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/core/helpers/objectMerger.js